import Handle from '~/prix/react/components/handle'
import Modal from '~/prix/react/components/modal'
import {
  BottomContainer,
  Content,
  GeneralInformation,
  Header,
  InfoCard,
  InfoContainer,
  Information,
  Input,
  Label,
  OtherInformation,
  RightBottomInformation,
  SectionGroup,
  Title,
  VisualCard,
  VisualCardBody,
  Wrapper,
} from './styles'
import { ObjectInfo } from './modalInformation'
import { applyMask } from './informationMasks'
import ShowStreetView from '~/components/mapContent/modals/clusterList/showStreetView'

interface GeneralPageInformationProps {
  isOpen: boolean
  onClose: () => void
  isLoading: boolean
  markerCoordinates?: { lat: number; lng: number }
  general: ObjectInfo
  sectionOne: ObjectInfo
  sectionTwo: ObjectInfo | null
  sectionThree: ObjectInfo | null
  title: string
  sectionOneTitle: string
  sectionTwoTitle: string
  sectionThreeTitle: string
}

const GeneralPageInformation = ({
  isOpen,
  onClose,
  isLoading,
  markerCoordinates,
  general,
  sectionTwo,
  sectionOne,
  sectionThree,
  title,
  sectionOneTitle,
  sectionTwoTitle,
  sectionThreeTitle,
}: GeneralPageInformationProps) => {
  const hasStreetView = isOpen && !!markerCoordinates

  function handleClose() {
    onClose()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} className='prix-modal-full'>
      <Handle isLoading={isLoading}>
        <Wrapper>
          <Title>
            <h2>{title}</h2>
          </Title>
          <Content>
            <InfoContainer $hasStreetView={hasStreetView}>
              {hasStreetView ? (
                <VisualCard>
                  <VisualCardBody>
                    <ShowStreetView coordinates={markerCoordinates} />
                  </VisualCardBody>
                </VisualCard>
              ) : null}
              <InfoCard>
                <GeneralInformation>
                  {general &&
                    Object.entries(general).map(([key, info]) => (
                      <Information key={key}>
                        <Label>{info.displayName}: </Label>
                        <Input
                          value={info.value ? applyMask(info.value, info.mask) : info.notAvailable}
                          disabled
                        />
                      </Information>
                    ))}
                </GeneralInformation>
              </InfoCard>
            </InfoContainer>

            {sectionOne && (
              <SectionGroup>
                <Header>{sectionOneTitle}</Header>
                <InfoCard>
                  <GeneralInformation>
                    {Object.entries(sectionOne).map(([key, info]) => (
                      <Information key={key}>
                        <Label>{info.displayName}: </Label>
                        <Input
                          value={info.value ? applyMask(info.value, info.mask) : info.notAvailable}
                          disabled
                        />
                      </Information>
                    ))}
                  </GeneralInformation>
                </InfoCard>
              </SectionGroup>
            )}

            {(sectionTwo || sectionThree) && (
              <OtherInformation>
                {sectionTwo && (
                  <BottomContainer>
                    <Header>{sectionTwoTitle}</Header>
                    <InfoCard>
                      <RightBottomInformation>
                        {Object.entries(sectionTwo).map(([key, info]) => (
                          <Information key={key}>
                            <Label>{info.displayName}: </Label>
                            <Input
                              value={
                                info.value ? applyMask(info.value, info.mask) : info.notAvailable
                              }
                              disabled
                            />
                          </Information>
                        ))}
                      </RightBottomInformation>
                    </InfoCard>
                  </BottomContainer>
                )}
                {sectionThree && (
                  <BottomContainer>
                    <Header>{sectionThreeTitle}</Header>
                    <InfoCard>
                      <RightBottomInformation>
                        {Object.entries(sectionThree).map(([key, info]) => (
                          <Information key={key}>
                            <Label>{info.displayName}: </Label>
                            <Input
                              value={
                                info.value ? applyMask(info.value, info.mask) : info.notAvailable
                              }
                              disabled
                            />
                          </Information>
                        ))}
                      </RightBottomInformation>
                    </InfoCard>
                  </BottomContainer>
                )}
              </OtherInformation>
            )}
          </Content>
        </Wrapper>
      </Handle>
    </Modal>
  )
}

export default GeneralPageInformation
